/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import classNames from 'classnames';
import HotelCardGalleryOverlay from './components/HotelCardGalleryOverlay';
import HotelCardFeatures from './components/HotelCardFeatures';
import HotelCardPrice from './components/HotelCardPrice';
import HotelCardLabels from './components/HotelCardLabels';
import type { MapHotelCardProps } from './types';
import { HOTEL_CARD_HOTEL_INFO, HOTEL_CARD_TEST_ID } from './constants';
import styles from './mapHotelCardSmall.module.css';
import {
  MAX_FEATURES_VISIBLE_VALUE,
  MAX_FEATURES_VISIBLE_VALUE_WITH_LIFT,
} from './components/HotelCardFeatures/constants';
import { sliceFeatures } from './components/HotelCardFeatures/utils';

const MapHotelCardSmall: React.FC<MapHotelCardProps> = (props) => {
  const {
    id,
    images,
    bonusCount,
    currencyCode,
    hotelPageVisited,
    stars,
    hotelName,
    hotelLocation,
    rating,
    features,
    instantConfirm,
    price,
    innerLabels,
    isHotelOnly,
    availability,
    hotelPageHref,
    openInCurrentTab,
    className,
    cashbackLabel,
    cashbackIconWebp,
    cashbackIconPng,
    cashbackTooltipText,
    labelColor,
    textColor,
    skiLiftDistance,
  } = props;

  const visibleFatures = skiLiftDistance
    ? sliceFeatures(features, MAX_FEATURES_VISIBLE_VALUE_WITH_LIFT)
    : sliceFeatures(features, MAX_FEATURES_VISIBLE_VALUE);

  return (
    <div
      data-testid={HOTEL_CARD_TEST_ID}
      className={classNames(styles.cardContainer, className)}
    >
      <HotelCardGalleryOverlay
        id={id}
        price={price}
        images={images}
        isSmall
        bonusCount={bonusCount}
        hotelPageVisited={hotelPageVisited}
        stars={stars}
        hotelName={hotelName}
        hotelLocation={hotelLocation}
        rating={rating}
        isMapCard
        hotelPageHref={hotelPageHref}
        openInCurrentTab={openInCurrentTab}
        cashbackTooltipText={cashbackTooltipText}
        labelColor={labelColor}
        textColor={textColor}
        cashbackLabel={cashbackLabel}
        cashbackIconWebp={cashbackIconWebp}
        cashbackIconPng={cashbackIconPng}
      />
      <a
        data-testid={HOTEL_CARD_HOTEL_INFO}
        href={hotelPageHref}
        target={openInCurrentTab ? '_self' : '_blank'}
        className={styles.hotelInfo}
      >
        <HotelCardFeatures
          isMobile
          features={visibleFatures}
          skiLiftDistance={skiLiftDistance}
        />
        <HotelCardLabels isMobile labels={innerLabels} />
        <HotelCardPrice
          availability={availability}
          instantConfirm={instantConfirm}
          isMobile
          isFlexDates={false}
          isMapCard
          price={price}
          currencyCode={currencyCode}
          isHotelOnly={isHotelOnly}
        />
      </a>
    </div>
  );
};

export default MapHotelCardSmall;
